// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--k6VZ2";
export var textSide = "styles-module--textSide--1TV8Y";
export var content = "styles-module--content--1D9Ac";
export var imageSide = "styles-module--imageSide--3-ySH";
export var logoWrapper = "styles-module--logoWrapper--Z6nZK";
export var imageCol = "styles-module--imageCol--bCTXI";
export var leftPart = "styles-module--leftPart--2pDm-";
export var rightPart = "styles-module--rightPart--38hBM";